import React, {FC} from "react"
import {WellnessLane, WellnessMedia} from "@irati/types"
import Slider from "@irati/ui/src/Slider"
import {Body, H3} from "@irati/ui/src/Typography"
import {FormattedMessage} from "@irati/utils/lang"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import {Card} from "@irati/ui/src/Layout"
import Flex from "@irati/ui/src/Flex"
import {useTheme} from "@irati/ui/src/global/useTheme"
import {SliderSettings} from "../containers/styled"
import MediaCard from "./MediaCard"
import {WellnessHandIcon} from "./WellnessHandIcon"

interface Props {
  lane: WellnessLane
  laneKey: number
  onShowAlert: (media: WellnessMedia) => void
}

export const FeaturedLane: FC<Props> = ({lane, laneKey, onShowAlert}) => {
  const theme = useTheme()

  return (
    <Card padding={3}>
      <Flex direction="column" gap={2}>
        <div>
          <Flex gap={2} alignItems="center" marginBottom>
            <WellnessHandIcon />
            <H3>{lane.title}</H3>
          </Flex>

          <Body maxWidth="none" color={theme.colors.greys.dark}>
            {lane.description}
          </Body>
        </div>

        {lane.mediaList?.length ? (
          <Slider maintainSameHeight gap={1} slidesToShow={lane.mediaCardCount} settings={SliderSettings}>
            {lane.mediaList?.map((m, index) => (
              <MediaCard
                media={m}
                key={m.uuid}
                lane={lane}
                lanePosition={laneKey + 1}
                mediaPositionInLane={index + 1}
                onShowAlert={() => onShowAlert(m)}
              />
            ))}
          </Slider>
        ) : null}

        <div>
          <ButtonRouterLink primary small to={`/featured`}>
            <FormattedMessage id="wellness.featureLane.button" />
          </ButtonRouterLink>
        </div>
      </Flex>
    </Card>
  )
}
